import { render, staticRenderFns } from "./rb_list.vue?vue&type=template&id=546ad451&scoped=true&"
import script from "./rb_list.vue?vue&type=script&lang=js&"
export * from "./rb_list.vue?vue&type=script&lang=js&"
import style0 from "./rb_list.vue?vue&type=style&index=0&id=546ad451&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ad451",
  null
  
)

export default component.exports